"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("./..");

var _2 = require("../..");

var css = _interopRequireWildcard(require("./TickerElement.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const textColors = {
  positive: 'text.positive',
  negative: 'text.negative',
  auto: 'text.3'
};
const TickerElement = /*#__PURE__*/React.forwardRef(({
  as = 'button',
  scripName,
  ltpChange,
  ...otherProps
}, ref) => {
  const variant = (0, _2.useValueChange)(ltpChange.change);
  const icons = React.useMemo(() => ({
    positive: (0, _pragma.createFelaElement)(_2.TrendingUpIcon, {
      css: css.icon,
      size: "xsmall",
      color: "text.positive"
    }),
    negative: (0, _pragma.createFelaElement)(_2.TrendingDownIcon, {
      css: css.icon,
      size: "xsmall",
      color: "text.negative"
    }),
    auto: null
  }), []);
  const textColor = textColors[variant];
  const trendingIcon = icons[variant];
  return (0, _pragma.createFelaElement)(React.Fragment, null, (0, _pragma.createFelaElement)(_.Text, {
    css: css.divider,
    lineHeight: "xs"
  }, "|"), (0, _pragma.createFelaElement)(_.View, _extends({
    alignItems: "center",
    as: as,
    css: css.root,
    gap: "xsmall",
    inline: true,
    padding: [12, 8],
    ref: ref
  }, otherProps), (0, _pragma.createFelaElement)(_.Text, {
    children: scripName,
    color: "text.3",
    transform: "uppercase",
    variant: "metaBold",
    css: css.scripName
  }), (0, _pragma.createFelaElement)(_.Text, {
    css: css.container,
    color: textColor,
    variant: "metaBold"
  }, (0, _pragma.createFelaElement)(_.View, {
    alignItems: "center"
  }, trendingIcon, (0, _pragma.createFelaElement)(_2.RupeeIcon, {
    color: textColor
  }), ltpChange.value))));
});
TickerElement.displayName = 'TickerElement';
var _default = TickerElement;
exports.default = _default;
//# sourceMappingURL=TickerElement.js.map